module.exports = __webpack_public_path__ + "static/media/image016.b27c9701.jpg";